const metric_values = (state) => state.metric_values;
const metric_value = (state) => state.metric_value;

export default {
  metric_values,
  metric_value,
};
